const CompanyActionTypes = {
  SET_COMPANY: 'SET_COMPANY',
};

export default CompanyActionTypes;
